import { Tag } from '@shared/components'
import React from 'react'

import { useGuardedNavigate } from '@/hooks/useGuardedNavigate'
import { HomeQualityCheckList, HomeQualityCheckStatus } from '@/types/HomeQualityCheck'
import { formatDate } from '@/util'

export const HomeQualityCheckListColumns = [
  {
    Header: 'Home',
    accessor: 'name',
    width: 60,
    Cell: function CellRenderer({ row }: { row: { original: HomeQualityCheckList } }) {
      const { home } = row.original
      const navigate = useGuardedNavigate()

      return (
        <>
          <p
            className="cursor-pointer leading-120 text-primary hover:underline"
            onClick={() => navigate(`/homes/${home.id}`)}
            role="presentation"
          >
            {home.searchDocument}
          </p>
        </>
      )
    },
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ value }: any) => {
      return (
        <Tag className="ml-2" variant={value === HomeQualityCheckStatus.READY ? 'success' : 'error'}>
          {value}
        </Tag>
      )
    },
    width: 30,
  },
  {
    Header: 'Previous Reservation',
    accessor: 'precedingReservationId',
    width: 75,
    Cell: function CellRenderer({ row }: { row: { original: HomeQualityCheckList } }) {
      const { precedingReservationId, precedingReservationMoveOutDate } = row.original
      const navigate = useGuardedNavigate()

      return (
        <>
          <p
            className="cursor-pointer leading-120 text-primary hover:underline"
            onClick={() => navigate(`/reservations/${precedingReservationId}`)}
            role="presentation"
          >
            {`Move-out: ${
              precedingReservationMoveOutDate
                ? formatDate(new Date(precedingReservationMoveOutDate || ''), 'MM-dd-yyyy')
                : 'Pending'
            }`}
          </p>
        </>
      )
    },
  },
  {
    Header: 'Upcoming Reservation',
    accessor: 'upcomingReservationId',
    width: 75,
    Cell: function CellRenderer({ row }: { row: { original: HomeQualityCheckList } }) {
      const { upcomingReservationId, upcomingReservationMoveInDate } = row.original
      const navigate = useGuardedNavigate()

      return (
        <>
          {upcomingReservationId ? (
            <p
              className="cursor-pointer leading-120 text-primary hover:underline"
              onClick={() => navigate(`/reservations/${upcomingReservationId}`)}
              role="presentation"
            >
              {`Move-in: ${
                upcomingReservationMoveInDate
                  ? formatDate(new Date(upcomingReservationMoveInDate || ''), 'MM-dd-yyyy')
                  : 'N/A'
              }`}
            </p>
          ) : (
            <p className="leading-120 text-primary">Move-in: N/A</p>
          )}
        </>
      )
    },
  },
  {
    Header: 'Notes',
    accessor: 'notes',
    width: 100,
  },
]
